import { Add, Delete, Edit } from "@mui/icons-material";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import { Autocomplete, Box, Button, Divider, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Switch, TextField, Tooltip, Typography } from "@mui/material"
import { deleteHoliday, getInvoicePreference, insertOrganizationpreference, updateGeoFencePreferences, updateWeekendData } from "api/services/preferencess";
import { snack } from "components/toast";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import UpdateWeekend from "./updateWeekend";
import UpdateOvertime from "./updateOvertime";
import moment from "moment";
import AddHoliday from "./addHoliday";
import Table from "components/Table";
import { useConfirm } from "context/ConfirmDialog";
import CampaignIcon from "@mui/icons-material/Campaign";
import AttendanceInfo from "./attendanceInfo";
import Announcement from "./../../../assets/images/Announcement.svg";
import DialogWrapper from "components/DialogWrapper";
import LoadingButton from "components/LoadingButton";

type GeoFenceLocation = {
    name: string;
    latitude: string;
    longitude: string;
    radiusMeters: string;
};

type GeoFencePreferences = {
    enabled: boolean;
    radiusMeters: string;
    locations: GeoFenceLocation[];
};

type GeoFenceLocationErrors = Partial<Record<keyof GeoFenceLocation, string>>;

const emptyGeoFenceLocation = (): GeoFenceLocation => ({
    name: "",
    latitude: "",
    longitude: "",
    radiusMeters: "",
});

const defaultGeoFencePreferences = (): GeoFencePreferences => ({
    enabled: false,
    radiusMeters: "100",
    locations: [emptyGeoFenceLocation()],
});

const getGeoFenceHelperText = (message?: string) => message === "Mandatory field" ? "" : message;

function AttendancePreferences() {
    const queryClient = useQueryClient();
    var currentYearString = moment().format('YYYY');
    var currentYearInt = parseInt(currentYearString, 10);
    const yearsArray = Array.from({ length: currentYearInt - 2009 + 1 }, (_, i) => 2010 + i);
    const sortedYearsArray = yearsArray.sort((a, b) => b - a);
    const [state, setState]: any = useState([]);
    const [weekendData, setWeekendData] = useState([]);
    const [hours, setHours] = useState<any>(null);
    const [minutes, setMinutes] = useState<any>(null);
    const [weekendEdit, setWeekendEdit] = useState<boolean>(false);
    const [overtimeEdit, setOvertimeEdit] = useState<boolean>(false);
    const [AddOpenHoliday, setAddOpenHoliday] = useState<boolean>(false);
    const [years, setyears] = useState<any>(sortedYearsArray);
    const [year, setYear] = useState<any>(currentYearInt);
    const [holidays, setHolidays] = useState<any>([]);
    const [totalHolidays, setTotalHolidays] = useState<any>([]);
    const [isMarkAbsent, setIsMarkAbsent] = useState<any>("NO");
    const [initialIsMarkAbsent, setInitialIsMarkAbsent] = useState<any>(null);
    const [openInfo, setOpenInfo] = useState(false);
    const [geoFenceOpen, setGeoFenceOpen] = useState(false);
    const confirm = useConfirm()

    const { data: invoicePreferences, isLoading: isInvoicePreferencesLoading } = useQuery(
        "attendance-preferences",
        getInvoicePreference,
        {
            onSuccess: (res: any) => {
                res?.data?.holidayPreferences?.addholiday.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());
                setTotalHolidays(res?.data?.holidayPreferences?.addholiday);
                const Yearholidays = res?.data?.holidayPreferences?.addholiday.filter((item: any) => moment(item?.date).format("YYYY") === String(year))
                setHolidays(Yearholidays);
                setWeekendData(res?.data?.holidayPreferences?.updateweekend);
                setHours(res.data.holidayPreferences.updateovertime.hours);
                setMinutes(res.data.holidayPreferences.updateovertime.minutes);
                const initialValue = res?.data?.holidayPreferences?.isMarkAbsent || "NO";
                setIsMarkAbsent(initialValue);
                setInitialIsMarkAbsent(initialValue);
            },
        }
    );
    useEffect(() => {
        const Yearholidays = totalHolidays.filter((item: any) => moment(item?.date).format("YYYY") === String(year))
        setHolidays(Yearholidays);
    }, [year])

    const onChange = (e: any) => {
        setYear(e.target.value);
    }

    const { mutate, isLoading: insertLoad } = useMutation(updateWeekendData, {
        onSuccess: () => {
            snack.success("Preferences Updated");
            queryClient.invalidateQueries("attendance-preferences");
        },
        onError: (err: any) => {
            snack.error(err);
        }
    });

    const handleUpdateIsAbsent = () => {
        const apiData = { typeofdata: "isMarkAbsent", data: { isMarkAbsent } }
        confirm({
            msg: "Are you sure, Employees Attendance should be marked as Absent",
            action: () => mutate({ data: apiData }),
        });
    }

    return (
        <Box sx={{ p: 3, pb: 0 }}>
            <Grid container mt={2} >
                <Grid item xs={4} >
                    <Box sx={{ border: "1px solid #cfcbd6", padding: "10px", borderRadius: "10px", mr: 1, height: "120px" }} >
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography sx={{ mt: 1, ml: 2 }} variant="h5">Weekend</Typography>
                            <IconButton onClick={(e) => setWeekendEdit(true)} sx={{ mr: 2 }}>
                                <Edit />
                            </IconButton>
                        </Box>
                        {/* <Box flexWrap="wrap" display="flex" p={2} >
                            {weekendData?.map((item: any, index: any) => (
                                <Box
                                    px="10px"
                                    py="5px"
                                    borderRadius={2}
                                    key={index}
                                    border="1px solid rgb(24, 47, 83, 0.2)"
                                    sx={{ mr: 2 }}
                                >
                                    <Typography color="primary" variant="caption" sx={{ fontWeight: "bold" }}>
                                        {item?.label}
                                    </Typography>
                                </Box>
                            ))}
                        </Box> */}
                        <Box flexWrap="wrap" display="flex" p={2}>
                            {weekendData?.slice(0, 2).map((item: any, index: number) => (
                                <Box
                                    key={index}
                                    px="10px"
                                    py="5px"
                                    borderRadius={2}
                                    border="1px solid rgb(24, 47, 83, 0.2)"
                                    sx={{ mr: 2 }}
                                >
                                    <Typography color="primary" variant="caption" sx={{ fontWeight: "bold" }}>
                                        {item?.label}
                                    </Typography>
                                </Box>
                            ))}

                            {weekendData?.length > 2 && (
                                <Box
                                    px="10px"
                                    py="5px"
                                    borderRadius={2}
                                    border="1px solid rgb(24, 47, 83, 0.2)"
                                    sx={{ mr: 2 }}
                                >
                                    <Typography color="primary" variant="caption" sx={{ fontWeight: "bold" }}>
                                        ...
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={4}>
                    <Box sx={{ border: "1px solid #cfcbd6", padding: "10px", borderRadius: "10px", ml: 1, height: "120px" }} >
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="h6" sx={{ mt: 0.5, ml: 2, fontSize: "20px" }} >Standard Working Hours in a Day</Typography>
                            <IconButton onClick={(e) => setOvertimeEdit(true)} sx={{ mr: 2 }}>
                                <Edit />
                            </IconButton>
                        </Box>
                        <Box textAlign={"center"} >
                            <Typography variant="body1" sx={{ fontSize: "20px" }}  >{hours ? hours['label'] : null} Hrs {minutes ? minutes["label"] : null} Mns</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={4}>
                    <Box sx={{ border: "1px solid #cfcbd6", padding: "10px", borderRadius: "10px", ml: 1, height: "120px" }} >
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Grid container>
                                <Grid item xs={8}>
                                    <Typography variant="h6" sx={{ mt: 1, ml: 1, fontSize: "15px" }} >
                                        Employees who fail to record their Attendance should be marked as Absent?
                                    </Typography>
                                </Grid>

                                <Grid item xs={4} >
                                    <FormControl style={{ marginTop: "10px" }}>
                                        <InputLabel>Status</InputLabel>
                                        <Select
                                            fullWidth
                                            size="small"
                                            placeholder="Absent"
                                            labelId="Mark Absent"
                                            id="isMarkAbsent"
                                            value={isMarkAbsent || "NO"}
                                            onChange={(event) => {
                                                setIsMarkAbsent(event.target.value); // Update state with the selected value
                                            }}
                                            label="Is Mark Absent"
                                        >
                                            <MenuItem key={"YES"} value="YES">
                                                YES
                                            </MenuItem>
                                            <MenuItem key={"NO"} value="NO">
                                                NO
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                    {isMarkAbsent !== initialIsMarkAbsent && ( // Show the button only if value changes
                                        <Button
                                            style={{ marginTop: "5px" }}
                                            color="secondary"
                                            variant="contained"
                                            onClick={handleUpdateIsAbsent}
                                        >
                                            Update
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>


                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} >
                    <Box sx={{ mt: 2 }} >
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h5" >List of Holidays</Typography>

                            <Box>
                                <Button
                                    onClick={() => setOpenInfo(true)}
                                    sx={{
                                        backgroundColor: "#fff",
                                        "&:hover": { backgroundColor: "#fff" },
                                        p: 0,
                                        minWidth: "auto",
                                        marginRight: "20px",
                                    }}
                                >
                                    <Tooltip title="Announcement">
                                        <img
                                            src={Announcement}
                                            alt="Announcement"
                                            style={{
                                                cursor: "pointer",
                                                width: 33,
                                                height: 33,
                                            }}
                                        />
                                    </Tooltip>
                                </Button>
                                <TextField
                                    name="category"
                                    value={year}
                                    onChange={onChange}
                                    size="small"
                                    label="Year"
                                    select
                                    sx={{ width: "250px" }}
                                >
                                    {years?.map((option: any, index: any) => (
                                        <MenuItem key={index} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                <Button
                                    sx={{ ml: 2, pt: 1 }}
                                    variant="outlined"
                                    startIcon={<Add />}
                                    color="secondary"
                                    onClick={() => setAddOpenHoliday(true)}
                                >Add Holiday</Button>


                                <Button
                                    sx={{ ml: 2, pt: 1 }}
                                    variant="outlined"
                                    color="secondary"
                                    startIcon={<Add />}
                                    onClick={() => setGeoFenceOpen(true)}
                                >
                                    Add Geo Fence
                                </Button>

                            </Box>
                        </Box>
                        <Box sx={{ mt: 1 }}>
                            <Table
                                data={holidays || []}
                                loading={false}
                                sx={{ height: "360px", mb: 0, pb: 0 }}
                                columns={[
                                    {
                                        title: "Date",
                                        key: "date",
                                        render: (row) => {
                                            return moment(row?.date).format("DD-MM-YYYY");
                                        },
                                    },
                                    {
                                        title: "Day",
                                        key: "date",
                                        render: (row) => {
                                            return moment(row?.date).format("dddd");
                                        }
                                    },
                                    {
                                        title: "Description",
                                        key: "holiday",
                                    },
                                    {
                                        key: "actions",
                                        title: "Actions",
                                        render: (row: any) => <Actions data={row} setTotalHolidays={setTotalHolidays} setHolidays={setHolidays} year={year} />,
                                    },
                                ]}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <UpdateWeekend open={weekendEdit} setOpen={setWeekendEdit} />
            <UpdateOvertime open={overtimeEdit} setOpen={setOvertimeEdit} />
            <AddHoliday open={AddOpenHoliday} setOpen={setAddOpenHoliday} />
            <AttendanceInfo open={openInfo} setOpen={setOpenInfo} />
            <GeoFencePreferencesDialog open={geoFenceOpen} setOpen={setGeoFenceOpen} />
        </Box>
    )
}

const GeoFencePreferencesDialog = ({ open, setOpen }) => {
    const queryClient = useQueryClient();
    const [preferences, setPreferences] = useState<GeoFencePreferences>(defaultGeoFencePreferences());
    const [geoOpenInfo, setGeoOpenInfo] = useState(false);
    const [fetchingLocationIndex, setFetchingLocationIndex] = useState<number | null>(null);
    const [defaultRadiusError, setDefaultRadiusError] = useState("");
    const [locationErrors, setLocationErrors] = useState<Record<number, GeoFenceLocationErrors>>({});

    const { isLoading: preferencesLoading } = useQuery(
        "attendance-preferences",
        getInvoicePreference,
        {
            enabled: open,
            onSuccess: (res: any) => {
                const geoFencePreferences = res?.data?.geoFencePreferences || {};
                const locations = Array.isArray(geoFencePreferences?.locations) && geoFencePreferences.locations.length
                    ? geoFencePreferences.locations
                    : [emptyGeoFenceLocation()];

                setPreferences({
                    enabled: geoFencePreferences?.enabled === true || geoFencePreferences?.enabled === "true",
                    radiusMeters: String(geoFencePreferences?.radiusMeters || "100"),
                    locations: locations.map((location: any) => ({
                        name: location?.name || "",
                        latitude: location?.latitude !== undefined && location?.latitude !== null ? String(location.latitude) : "",
                        longitude: location?.longitude !== undefined && location?.longitude !== null ? String(location.longitude) : "",
                        radiusMeters: location?.radiusMeters !== undefined && location?.radiusMeters !== null ? String(location.radiusMeters) : "",
                    })),
                });
                setDefaultRadiusError("");
                setLocationErrors({});
            },
        }
    );

    const { mutate, isLoading: isSaving } = useMutation(updateGeoFencePreferences, {
        onSuccess: () => {
            snack.success("Geo Fence Preferences Updated");
            queryClient.invalidateQueries("attendance-preferences");
            setOpen(false);
        },
        onError: (err: any) => {
            snack.error(err?.response?.data?.message || "Failed to update geo fence preferences");
        },
    });

    const updateLocation = (index: number, field: keyof GeoFenceLocation, value: string) => {
        setPreferences((prev) => ({
            ...prev,
            locations: prev.locations.map((location, locationIndex) =>
                locationIndex === index ? { ...location, [field]: value } : location
            ),
        }));
        setLocationErrors((prev) => ({
            ...prev,
            [index]: {
                ...prev[index],
                [field]: "",
            },
        }));
    };

    const handleAddLocation = () => {
        setPreferences((prev) => ({
            ...prev,
            locations: [...prev.locations, emptyGeoFenceLocation()],
        }));
    };

    const handleRemoveLocation = (index: number) => {
        setPreferences((prev) => ({
            ...prev,
            locations: prev.locations.length === 1
                ? [emptyGeoFenceLocation()]
                : prev.locations.filter((_, locationIndex) => locationIndex !== index),
        }));
    };

    const handleUseCurrentLocation = (index: number) => {
        if (!navigator.geolocation) {
            snack.error("Geolocation is not supported in this browser");
            return;
        }

        setFetchingLocationIndex(index);
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setPreferences((prev) => ({
                    ...prev,
                    locations: prev.locations.map((location, locationIndex) =>
                        locationIndex === index
                            ? {
                                ...location,
                                latitude: String(position.coords.latitude),
                                longitude: String(position.coords.longitude),
                            }
                            : location
                    ),
                }));
                setFetchingLocationIndex(null);
            },
            (error) => {
                setFetchingLocationIndex(null);
                snack.error("Location error: " + (error?.message || "Unable to get current location"));
            },
            { enableHighAccuracy: true, timeout: 10000 }
        );
    };

    const handleSave = () => {
        const radiusMeters = Number(preferences.radiusMeters);
        const nextLocationErrors: Record<number, GeoFenceLocationErrors> = {};
        let nextDefaultRadiusError = "";

        if (!Number.isFinite(radiusMeters) || radiusMeters <= 0) {
            nextDefaultRadiusError = "Mandatory field";
        }

        preferences.locations.forEach((location, index) => {
            const rowErrors: GeoFenceLocationErrors = {};
            const latitudeText = String(location.latitude ?? "").trim();
            const longitudeText = String(location.longitude ?? "").trim();
            const radiusText = String(location.radiusMeters ?? "").trim();
            const latitude = Number(latitudeText);
            const longitude = Number(longitudeText);
            const rowRadius = radiusText ? Number(radiusText) : radiusMeters;

            if (!location.name.trim()) rowErrors.name = "Mandatory field";
            if (!latitudeText) rowErrors.latitude = "Mandatory field";
            else if (!Number.isFinite(latitude) || latitude < -90 || latitude > 90) rowErrors.latitude = "Invalid latitude";
            if (!longitudeText) rowErrors.longitude = "Mandatory field";
            else if (!Number.isFinite(longitude) || longitude < -180 || longitude > 180) rowErrors.longitude = "Invalid longitude";
            if (radiusText && (!Number.isFinite(rowRadius) || rowRadius <= 0)) rowErrors.radiusMeters = "Invalid radius";
            if (latitude === 0 && longitude === 0) {
                rowErrors.latitude = rowErrors.latitude || "Invalid location";
                rowErrors.longitude = rowErrors.longitude || "Invalid location";
            }

            if (Object.keys(rowErrors).length) {
                nextLocationErrors[index] = rowErrors;
            }
        });

        if (preferences.enabled && (nextDefaultRadiusError || Object.keys(nextLocationErrors).length)) {
            setDefaultRadiusError(nextDefaultRadiusError);
            setLocationErrors(nextLocationErrors);
            snack.error("Please fill all mandatory geo fence fields");
            return;
        }

        setDefaultRadiusError("");
        setLocationErrors({});

        const enteredLocations = preferences.locations
            .map((location) => ({
                name: location.name.trim(),
                latitudeText: String(location.latitude ?? "").trim(),
                longitudeText: String(location.longitude ?? "").trim(),
                radiusText: String(location.radiusMeters ?? "").trim(),
            }))
            .filter((location) => location.name && location.latitudeText && location.longitudeText);
        const normalizedLocations = enteredLocations.map((location) => ({
            name: location.name,
            latitude: Number(location.latitudeText),
            longitude: Number(location.longitudeText),
            radiusMeters: location.radiusText ? Number(location.radiusText) : radiusMeters,
            latitudeText: location.latitudeText,
            longitudeText: location.longitudeText,
        }));

        if (preferences.enabled) {
            if (!normalizedLocations.length) {
                snack.error("Please add at least one geo fence location");
                return;
            }
        }

        mutate({
            data: {
                geoFencePreferences: {
                    enabled: preferences.enabled,
                    radiusMeters,
                    locations: normalizedLocations.map(({ latitudeText, longitudeText, ...location }) => location),
                },
            },
        });
    };

    return (
        <DialogWrapper open={open} title="Geo Fence Preferences" setOpen={setOpen} width="xl">
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pb: 1, maxHeight: "72vh", overflowY: "auto" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, flexWrap: "wrap", pt: 1 }}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <FormControlLabel
                            sx={{ minWidth: 190 }}
                            control={
                                <Switch
                                    checked={preferences.enabled}
                                    onChange={(event) => setPreferences((prev) => ({ ...prev, enabled: event.target.checked }))}
                                />
                            }
                            label="Enable Geo Fence"
                        />

                        <Box sx={{ width: 330 }}>
                            <TextField
                            label="Default Radius (m)"
                            size="small"
                            type="number"
                            value={preferences.radiusMeters}
                            onChange={(event) => {
                                setPreferences((prev) => ({ ...prev, radiusMeters: event.target.value }));
                                setDefaultRadiusError("");
                            }}
                            InputProps={{ inputProps: { min: 1 } }}
                            error={Boolean(defaultRadiusError)}
                            helperText={defaultRadiusError}
                            fullWidth
                        />
                            {/* <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.75, lineHeight: 1.4 }}>
                            Used when a location does not have its own radius.
                        </Typography> */}
                        </Box>
                    </Box>
                    <Button
                        onClick={() => setGeoOpenInfo(true)}
                        sx={{
                            backgroundColor: "#fff",
                            "&:hover": { backgroundColor: "#fff" },
                            p: 0,
                            minWidth: "auto",
                            paddingRight: 2
                        }}
                    >
                        <Tooltip title="Announcement">
                            <img
                                src={Announcement}
                                alt="Announcement"
                                style={{ cursor: "pointer", width: 33, height: 33 }}
                            />
                        </Tooltip>
                    </Button>
                </Box>

                <Divider />

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography variant="subtitle1" fontWeight={600}>Locations</Typography>
                    <Button size="small" startIcon={<Add />} onClick={handleAddLocation}>
                        Add
                    </Button>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    {preferences.locations.map((location, index) => (
                        <Paper key={index} variant="outlined" sx={{ p: 1.25, borderRadius: 1 }}>
                            <Grid container spacing={1.25} alignItems="flex-start">
                                <Grid item xs={12} md={1.1}>
                                    <Typography variant="subtitle2" sx={{ height: 40, display: "flex", alignItems: "center" }}>
                                        Location {index + 1}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        label="Location Name *"
                                        size="small"
                                        value={location.name}
                                        onChange={(event) => updateLocation(index, "name", event.target.value)}
                                        error={Boolean(locationErrors[index]?.name)}
                                        helperText={getGeoFenceHelperText(locationErrors[index]?.name)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    <TextField
                                        label="Latitude *"
                                        size="small"
                                        type="number"
                                        value={location.latitude}
                                        onChange={(event) => updateLocation(index, "latitude", event.target.value)}
                                        error={Boolean(locationErrors[index]?.latitude)}
                                        helperText={getGeoFenceHelperText(locationErrors[index]?.latitude)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    <TextField
                                        label="Longitude *"
                                        size="small"
                                        type="number"
                                        value={location.longitude}
                                        onChange={(event) => updateLocation(index, "longitude", event.target.value)}
                                        error={Boolean(locationErrors[index]?.longitude)}
                                        helperText={getGeoFenceHelperText(locationErrors[index]?.longitude)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    <TextField
                                        label="Radius"
                                        size="small"
                                        type="number"
                                        value={location.radiusMeters}
                                        onChange={(event) => updateLocation(index, "radiusMeters", event.target.value)}
                                        InputProps={{ inputProps: { min: 1 } }}
                                        placeholder={preferences.radiusMeters}
                                        error={Boolean(locationErrors[index]?.radiusMeters)}
                                        helperText={locationErrors[index]?.radiusMeters}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={1.9}>
                                    <Box sx={{ height: 40, display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 0.5 }}>
                                        {fetchingLocationIndex === index && (
                                            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
                                                Fetching location
                                            </Typography>
                                        )}
                                        <Tooltip title="Use current location">
                                            <IconButton
                                                size="small"
                                                disabled={fetchingLocationIndex !== null}
                                                onClick={() => handleUseCurrentLocation(index)}
                                            >
                                                <MyLocationIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete location">
                                            <IconButton size="small" onClick={() => handleRemoveLocation(index)}>
                                                <Delete fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>
                    ))}
                </Box>

                <LoadingButton
                    title="Save Geo Fence"
                    loading={isSaving || preferencesLoading}
                    onClick={handleSave}
                    color="secondary"
                    fullWidth
                />
            </Box>
            <GeoFenceInfo open={geoOpenInfo} setOpen={setGeoOpenInfo} />
        </DialogWrapper>
    );
};

const Actions = ({ data, setTotalHolidays, setHolidays, year }) => {
    const confirm = useConfirm();

    const { mutateAsync } = useMutation(deleteHoliday, {
        onSuccess: (res: any) => {
            setTotalHolidays(res?.data?.holidayPreferences?.addholiday);
            const Yearholidays = res?.data?.holidayPreferences?.addholiday.filter((item: any) => moment(item?.date).format("YYYY") === String(year))
            setHolidays(Yearholidays);
            snack.success("Holiday Deleted");
        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });

    const handleDelete = () => {
        confirm({
            msg: "Are you sure you want to delete this Holiday?",
            action: () => mutateAsync(data),
        });
    };

    return (
        <Box>
            <Box display="flex" gap={1}>
                <IconButton size="small" onClick={handleDelete}>
                    <Delete />
                </IconButton>
            </Box>
        </Box>
    );
};



const GeoFenceInfo = ({ open, setOpen }: { open: boolean; setOpen: (open: boolean) => void }) => {
    const points = [
        "Default radius applies to all locations that do not have their own radius.",
        "Add a separate location for each branch, office, or allowed workplace.",
        "Do not add duplicate locations for the same address.",
        "Use the current location button while physically present at the office for better accuracy.",
        "Update coordinates immediately if the office relocates.",
        "Turn Enable Geo Fence on to activate location-based attendance.",
        "If Enable Geo Fence is off, employees can mark attendance from anywhere.",
    ];

    return (
        <DialogWrapper
            title="Important Information on Geo Fence"
            open={open}
            setOpen={setOpen}
            width="md"
        >
            <Box sx={{ padding: 2, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
                <Box component="ul" sx={{ pl: 2.5, my: 1 }}>
                    {points.map((point) => (
                        <Typography component="li" variant="body2" key={point} sx={{ mb: 0.75 }}>
                            {point}
                        </Typography>
                    ))}
                </Box>
                <Typography variant="body2" color="text.secondary">
                    Please avoid manually copying coordinates from Google Maps. Go to the actual location and use the current location button to capture the most accurate coordinates.
                </Typography>
            </Box>
        </DialogWrapper>
    )
}


export default AttendancePreferences
